import React from 'react'

const BottomBar = () => {
  return (
    <div style={{textAlign : 'center' , 
    lineHeight : 1 , 
    fontStyle : 'italic',
    color: '#FFFFFF'
    }}>
       <p >School Manager</p>
       <p>Application developpée par @DaVinci Dynamics</p>
    </div>
  )
}

export default BottomBar